import {
  FILTER_TYPES,
  ReportFilterConfigBase,
} from "../../filters/config/types";

const formTypeOptions = [
  { label: "ALL", value: "" },
  { label: "Invoice", value: "INVOICE" },
  { label: "Deposit Invoice", value: "DEPOSIT INVOICE" },
];

export const Filters: ReportFilterConfigBase[] = [
  {
    label: "Refund date",
    type: FILTER_TYPES.DateRange,
    fields: ["category_refund_date", "start_refund_date", "end_refund_date"],
    defaultValue: ["", "", ""],
  },
  {
    label: "Client",
    type: FILTER_TYPES.Client,
    fields: "client_id",
  },
  {
    label: "Order Rep",
    type: FILTER_TYPES.User,
    fields: ["sales_rep_id", "sales_rep_team_ids", "include_inactive_sales_reps"],
  },
  {
    label: "Form type",
    type: FILTER_TYPES.GenericSelect,
    options: formTypeOptions,
    fields: "form_type",
    defaultValue: "",
  },
  {
    label: "Project",
    fields: "project_search",
    type: FILTER_TYPES.Query,
    fetchReportOnEnterPress: true,
  },
];
